<template>
  <el-dialog
    v-drag
    v-loading="loading"
    :title="isView ? '查看进口商' : (rowData?.id ? '修改进口商' : '新增进口商')"
    :visible.sync="dialogVisible"
    width="1150px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="6vh">
    <div class="content">
      <el-form ref="form" :model="form" :rules="rules" label-position="top" :disabled="isView">
        <el-row :gutter="17">
          <el-col :span="8">
            <el-form-item label="进口商名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status" style="width: 100%" placeholder="请选择">
                <el-option
                  v-for="item in config.importerStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="EIN NO" prop="taxNo">
              <el-input v-model="form.taxNo" placeholder="请输入" maxlength="12" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="row">
          <el-form-item label="法人" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="BOND Number" prop="bondNumber">
            <el-input v-model="form.bondNumber" placeholder="请输入" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="BOND额度" prop="bondTotal">
            <NumberPoint v-model="form.bondTotal" placeholder="请输入" style="width: 220px;"></NumberPoint>
          </el-form-item>
          <el-form-item label="归属" prop="belong">
            <el-radio-group v-model="form.belong" @change="handleBelongChange">
              <el-radio :label="0">内部</el-radio>
              <el-radio :label="1">外部</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <span v-if="form.belong" style="color: red;">*</span>
          <el-form-item v-if="form.belong" label="公司" prop="newSCINCompanyId">
            <el-select v-model="form.newSCINCompanyId" placeholder="请选择" filterable style="width: 280px;">
              <el-option
                v-for="item in companyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
        </div>
        <div class="row">
          <el-form-item label="Surety Code" prop="suretyCode">
            <el-select v-model="form.suretyCode" filterable clearable placeholder="请选择" style="width: 220px;">
              <el-option label="054" value="054"></el-option>
              <el-option label="856" value="856"></el-option>
              <el-option label="036" value="036"></el-option>
              <el-option label="300" value="300"></el-option>
              <el-option label="846" value="846"></el-option>
              <el-option label="873" value="873"></el-option>
              <el-option label="128" value="128"></el-option>
              <el-option label="664" value="664"></el-option>
              <el-option label="353" value="353"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="买BOND代理" prop="bondSupplierId">
            <el-select v-model="form.bondSupplierId" placeholder="请选择" style="width: 220px;" filterable clearable>
              <el-option
                v-for="item in supplierOptions"
                :key="item.id"
                :label="item.code + '-' + item.wbName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年审截止时间" prop="yearAuditDeadlineDate">
            <el-date-picker
              v-model="form.yearAuditDeadlineDate"
              style="width: 220px"
              type="date"
              align="center"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报税截止时间" prop="bondedDeadlineDate">
            <el-date-picker
              v-model="form.bondedDeadlineDate"
              style="width: 280px"
              type="date"
              align="center"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="注册时间" prop="registerDate">
            <el-date-picker
              v-model="form.registerDate"
              style="width: 220px"
              type="date"
              align="center"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="生效日期" prop="effectiveDate">
            <el-date-picker
              v-model="form.effectiveDate"
              style="width: 220px"
              type="date"
              align="center"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间" prop="closeDate">
            <el-date-picker
              v-model="form.closeDate"
              style="width: 220px"
              type="date"
              align="center"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="BOI是否" prop="isBOI">
            <el-switch v-model="form.isBOI" :active-text="form.isBOI ? '是' : '否'">
            </el-switch>
          </el-form-item>
          <el-form-item label="月结是否" prop="isMonthEnd">
            <el-switch v-model="form.isMonthEnd" :active-text="form.isMonthEnd ? '是' : '否'">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否禁用" prop="isActived">
            <el-switch v-model="form.isActived" :active-text="form.isActived ? '是' : '否'">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否敏感进口商" prop="isSensitiveImporter">
            <el-switch v-model="form.isSensitiveImporter" :active-text="form.isSensitiveImporter ? '是' : '否'">
            </el-switch>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="国家" prop="countryId">
            <el-select
              v-model="form.countryId"
              filterable
              placeholder="请选择"
              style="width: 220px;"
              @change="handleCountry">
              <el-option
                v-for="item in countryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省州" prop="provinceId">
            <el-select v-model="form.provinceId" filterable placeholder="请选择" style="width: 220px;">
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市" prop="cityAddress">
            <el-input
              v-model="form.cityAddress"
              placeholder="请输入"
              style="width: 220px;"
              @input="onInput('cityAddress')"></el-input>
          </el-form-item>
          <el-form-item label="邮编" prop="postcode">
            <NumberPoint v-model="form.postcode" placeholder="请输入" style="width: 280px;" decimalPlaces="0">
            </NumberPoint>
          </el-form-item>
        </div>
        <el-row :gutter="17">
          <el-col :span="8">
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入"
                style="width: 100%;"
                @input="onInput('address')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款方式" prop="paymentType">
              <el-select v-model="form.paymentType" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in paymentTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" placeholder="请输入" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="isView">
          <el-form-item label="供应商" prop="supplierIds">
            <el-select v-model="supplierIds" placeholder="请选择" style="width: 100%;" filterable multiple clearable collapse-tags>
              <el-option v-for="item in supplierOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-switch
            v-model="form.isF865"
            active-text="F865">
          </el-switch>
          <el-form-item v-if="form.isF865" label="NAICS Code" prop="naicsId">
            <!-- <el-select v-model="supplierIds" placeholder="请选择" style="width: 100%;" filterable multiple clearable collapse-tags>
              <el-option v-for="item in supplierOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
            <custom-select ref="customSelect1" v-model="form.naicsId" :value="form.naicsId" width="1070px" :selectItems="naicsOptions"></custom-select>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span v-show="!isView" slot="footer" class="footers flex_c_c">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-debounce-click="{ value: ok, args: ['form'] }" class="ok flex_c_c">
        确定
      </div>
    </span>
  </el-dialog>
</template>

<script>
const NumberPoint = () => import('@/components/base/NumberPoint.vue')
import { saveImporter, getPaymentTypeOption, searchNaicsCode } from '@/api/system'
import CustomSelect from './CustomSelect.vue'
import { getAddress } from '@/api/setting'
import config from '@/utils/config'
export default {
  components: {
    NumberPoint,
    CustomSelect
  },
  props: {
    dialogVisible: Boolean,
    rowData: Object,
    companyOptions: Array,
    userGroupOptions: Array,
    supplierOptions: Array,
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateTaxNo = (rule, value, callback) => {
      !value && callback(new Error('请输入税号'))
      value.length !== 12 && callback(new Error('请输入12位税号 不足12位补充00'))
      if (value && value.length === 12) {
        callback()
      }
    }
    return {
      config,
      loading: false,
      form: {
        importerId: '',
        name: '',
        paymentType: '',
        status: '',
        taxNo: '',
        belong: 1,
        newSCINCompanyId: '',
        contact: '',
        bondNumber: '',
        bondTotal: '',
        suretyCode: '',
        bondSupplierId: '',
        yearAuditDeadlineDate: '',
        bondedDeadlineDate: '',
        registerDate: '',
        effectiveDate: '',
        closeDate: '',
        isBOI: false,
        isMonthEnd: false,
        isActived: false,
        isSensitiveImporter: false,
        countryId: '',
        provinceId: '',
        cityAddress: '',
        postcode: '',
        address: '',
        remark: '',
        isF865: false,
        naicsId: ''
      },
      rules: {
        name: [{ required: true, message: '请输入进口商名称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入法人名称', trigger: 'blur' }],
        bondNumber: [{ required: false, message: '请输入BOND Number', trigger: 'blur' }],
        bondTotal: [{ required: true, message: '请输入BOND额度', trigger: 'blur' }],
        belong: [{ required: true, message: '请选择归属', trigger: 'change' }],
        suretyCode: [{ required: true, message: '请选择Surety Code', trigger: 'change' }],
        bondSupplierId: [{ required: true, message: '请选择买BOND代理', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        countryId: [{ required: true, message: '请选择国家', trigger: 'change' }],
        provinceId: [{ required: true, message: '请选择省州', trigger: 'change' }],
        cityAddress: [{ required: true, message: '请输入城市', trigger: 'blur' }],
        postcode: [{ required: true, message: '请输入邮编', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        effectiveDate: [{ required: true, message: '请输入生效日期', trigger: 'blur' }],
        closeDate: [{ required: true, message: '请输入截止日期', trigger: 'blur' }],
        isMonthEnd: [{ required: true, message: '请选中月结', trigger: 'blur' }],
        taxNo: [{ required: true, validator: validateTaxNo, trigger: 'blur' }],
        naicsId: [{ required: true, message: '请选择NAICS代码', trigger: 'change' }]
        // newSCINCompanyId: [{
        //   validator: (rule, value, callback) => {
        //     // 当 belong === 1（外部）时，才要求必填
        //     if (this.form.belong === 1) {
        //       if (!value || value === '') {
        //         callback(new Error('请选择公司'))
        //       } else {
        //         callback()
        //       }
        //     } else {
        //       callback()
        //     }
        //   },
        //   trigger: 'change'
        // }
        // ]
      },
      supplierIds: [],
      countryOptions: [],
      stateOptions: [],
      paymentTypeOptions: [],
      naicsOptions: []
    }
  },
  watch: {
    async dialogVisible(v) {
      if (v) {
        this.reset()
        await this.getAddress()
        await this.getPaymentTypeOption()
        await this.getNaicsOptions()
        if (this.rowData?.id) {
          const {
            importerId, paymentType, name, status, taxNo, belong, newSCINCompanyId, contact,
            bondNumber, bondTotal, suretyCode, bondSupplierId,
            yearAuditDeadlineDate, bondedDeadlineDate, registerDate, effectiveDate,
            closeDate, remark, isBOI, isMonthEnd, isActived, isSensitiveImporter, countryId,
            provinceId, cityAddress, postcode, address, naicsId
          } = this.rowData
          if (this.rowData.countryId !== undefined && this.rowData.countryId > 0) {
            const country = this.countryOptions.find(a => a.value === this.rowData.countryId)
            this.stateOptions = country?.children || []
          }
          this.form = Object.assign(this.form, {
            importerId,
            paymentType,
            name,
            status,
            belong,
            newSCINCompanyId,
            bondNumber,
            bondTotal,
            suretyCode,
            bondSupplierId,
            yearAuditDeadlineDate,
            bondedDeadlineDate,
            registerDate,
            effectiveDate,
            closeDate,
            remark,
            isBOI,
            isMonthEnd,
            isActived,
            isSensitiveImporter,
            countryId,
            provinceId,
            cityAddress,
            address,
            postcode,
            taxNo,
            contact,
            naicsId: this.naicsOptions.find(a => a.id === naicsId)?.code,
            isF865: !!naicsId
          })
          this.supplierIds = this.rowData.supplierIds
        }
      }
    }
  },
  methods: {
    handleBelongChange() {
      if (this.form.belong === 0) {
        this.form.newSCINCompanyId = ''
        // 如果需要，也可以清除其他外部专属字段
      }
    },
    onInput(type) {
      type === 'cityAddress' &&
        this.$set(
          this.form,
          'cityAddress',
          this.form.cityAddress.replace(/[^a-zA-Z&,()\s\d]/g, '')
        )
      type === 'address' &&
        this.$set(
          this.form,
          'address',
          this.form.address.replace(/[^0-9a-zA-Z&,()\s]/g, '')
        )
    },
    async getAddress() {
      try {
        const res = await getAddress()
        if (res.success) {
          const { data } = res
          this.countryOptions = data.country
        } else {
          this.$message(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    getPaymentTypeOption() {
      getPaymentTypeOption().then((res) => {
        if (res.success) {
          this.paymentTypeOptions = res.data
        } else {
          this.$message(res.errorMessage)
        }
      })
    },
    async getNaicsOptions() {
      try {
        const res = await searchNaicsCode()
        if (res.success) {
          this.naicsOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    reset() {
      this.form = this.$options.data().form
      this.supplierIds = []
      this.$refs.form?.resetFields()
    },
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          try {
            const params = {
              ...this.form,
              naicsId: this.form.isF865 ? this.naicsOptions.find(a => a.code === this.form.naicsId)?.id : undefined,
              id: this.rowData.id || undefined
            }
            const res = await saveImporter(params)
            this.loading = false
            if (res.success) {
              this.$message.success(res.errorMessage)
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            this.loading = false
            console.error(error)
          }
        }
      })
    },
    handleCountry(v) {
      this.form.provinceId = ''
      const stateOptions = this.countryOptions.find(
        (a) => a.value === v
      ).children
      this.stateOptions = stateOptions
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 40px);
  margin: 0 auto;
  margin-top: -20px;

  /deep/ .el-form--label-top .el-form-item__label {
    line-height: 30px;
    padding: 0;
  }

  .el-form {
    .row {
      display: flex;
      flex-wrap: wrap;

      .el-form-item+.el-form-item {
        margin-left: 17px;
      }
    }
  }
}

.footers {
  width: 100%;

  &>div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }

  .cancel {
    background: #eeeeee;
    color: #666666;
    margin-right: 16px;
  }

  .ok {
    background: #142e79;
    color: #ffffff;
  }
}
</style>
